import {useContext} from 'react';
import {AuthContext} from 'src/contexts/auth/appAuth-context';

export const useAuth = () => useContext(AuthContext);
